import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import styles from './styles.module.scss';
import config from '../../config/common';

const ErrorIndicator = () => (
  <div className={styles.errorIndicatorContainer}>
    <FormattedMessage
      id={"common.error.message"}
      values={{
        a: str => <a href={`mailto:${config.supportEmail}`} className={styles.mailToSupport}>{str}</a>
      }}
    />
  </div>
);

ErrorIndicator.propTypes = {
    message: PropTypes.node
};

export default ErrorIndicator;
